module.exports = __webpack_public_path__ + "img/learning.55111e64.svg";